// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-navigation--menu--main .el-menu-item i.fas{color:#199b39;font-size:14px;font-style:normal;font-weight:900;line-height:14px;margin-right:8px;min-width:18px;display:inline-block}.lad-navigation--menu--main .el-menu-item span{font-size:16px;font-weight:700;letter-spacing:0;color:#4c4f56}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
